import { __assign } from 'tslib';
import { SET_BUTTON_ID, OPEN_TOGGLETIP, CLOSE_TOGGLETIP } from './actions.js';

/**
 * Following the reducer pattern to manage context state from reach-ui `MenuButton`
 * https://github.com/reach/reach-ui/tree/main/packages/menu-button
 *
 */
function reducer(state, action) {
    if (action === void 0) { action = {}; }
    switch (action.type) {
        case CLOSE_TOGGLETIP:
            return __assign(__assign({}, state), { isOpen: false });
        case OPEN_TOGGLETIP:
            return __assign(__assign({}, state), { isOpen: true });
        case SET_BUTTON_ID:
            return __assign(__assign({}, state), { buttonId: action.payload });
        default:
            return state;
    }
}

export { reducer };
//# sourceMappingURL=reducer.js.map
